import { Alert, AlertType } from '@design/components/alert/Alert';
import { Icon } from '@design/components/icon/Icon';
import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './InlineAlert.module.scss';

interface InlineAlertProps {
  alertType: 'exceededLimit' | 'onlyOneSource';
}

export const InlineAlert = ({ alertType }: InlineAlertProps) => {
  const { t } = useTranslation(['chat']);

  return (
    <Alert
      className={styles.alert}
      type={AlertType.Info}
      variant="inline"
      message={
        alertType === 'exceededLimit'
          ? t('chat:trustedSources.modal.exceededLimit')
          : t('chat:trustedSources.modal.onlyOneSource')
      }
      customIcon={
        <Icon
          fillColor="var(--icon-primary)"
          iconName="InformationCircle"
          size={20}
        />
      }
    />
  );
};
